import { render, staticRenderFns } from "./authority-letter.vue?vue&type=template&id=63933152&scoped=true&"
import script from "./authority-letter.vue?vue&type=script&lang=js&"
export * from "./authority-letter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63933152",
  null
  
)

export default component.exports